import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// PHASE 8.44 — Wait for the inline boot fetch in public/index.html to finish
// before rendering React. The boot script fires `/site-content`, `/profile-dna`
// and `/sectors` in parallel the instant the HTML parser sees it. By the time
// the JS bundle is ready (~50–300ms after page load on a warm cache), the
// boot data is usually already on `window.__OODEL_BOOT__`. We hold React's
// first render for AT MOST 600ms — if the API is slow we proceed anyway and
// fall back to the legacy localStorage path (no white-screen lock).
const BOOT_TIMEOUT_MS = 600;
const bootPromise = (typeof window !== "undefined" && window.__OODEL_BOOT_PROMISE__) || Promise.resolve();
const timeoutPromise = new Promise((resolve) => setTimeout(resolve, BOOT_TIMEOUT_MS));

Promise.race([bootPromise, timeoutPromise]).then(() => {
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
});
